import React from "react";
import * as styles from "./new-footer.module.scss";
import { Link } from "gatsby";
import { phoneNum, phoneNumHref } from "../../../shared/data";
import { useTranslation } from "react-i18next";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CookieConsentComponent from "../../cookie-consent/cookie-consent";

export const NewFooter = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footer__top}>
        <div className={styles.footer__bl}>
          <h2 className={styles.footer__title}>{t("footer.social_title")}</h2>
          <p className={styles.footer__descript}>
            {t("footer.social_description")}
          </p>
          <ul className={styles.footer__social}>
            <li className={styles.footer__li}>
              <a
                href="https://www.instagram.com/daigo.sushi?igsh=dDh0ZWo1MXdvMHZ4"
                target="_blank"
                className={styles.footer__socLink}
              >
                <svg
                  viewBox="0 0 27 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 8C5 6.93913 5.44777 5.92172 6.2448 5.17157C7.04183 4.42143 8.12283 4 9.25 4H17.75C18.8772 4 19.9582 4.42143 20.7552 5.17157C21.5522 5.92172 22 6.93913 22 8V16C22 17.0609 21.5522 18.0783 20.7552 18.8284C19.9582 19.5786 18.8772 20 17.75 20H9.25C8.12283 20 7.04183 19.5786 6.2448 18.8284C5.44777 18.0783 5 17.0609 5 16V8Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M10.3125 12C10.3125 12.7956 10.6483 13.5587 11.2461 14.1213C11.8439 14.6839 12.6546 15 13.5 15C14.3454 15 15.1561 14.6839 15.7539 14.1213C16.3517 13.5587 16.6875 12.7956 16.6875 12C16.6875 11.2044 16.3517 10.4413 15.7539 9.87868C15.1561 9.31607 14.3454 9 13.5 9C12.6546 9 11.8439 9.31607 11.2461 9.87868C10.6483 10.4413 10.3125 11.2044 10.3125 12Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M18.2812 7.5V7.51"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </a>
            </li>
            {/* <li className={styles.footer__li}>
							<a href="#facebook" target="_blank" className={styles.footer__socLink}>
								<svg viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8.1875 10V14H11.375V21H15.625V14H18.8125L19.875 10H15.625V8C15.625 7.73478 15.7369 7.48043 15.9362 7.29289C16.1355 7.10536 16.4057 7 16.6875 7H19.875V3H16.6875C15.2785 3 13.9273 3.52678 12.931 4.46447C11.9347 5.40215 11.375 6.67392 11.375 8V10H8.1875Z"
										strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</a>
						</li>  */}
            <li className={styles.footer__li}>
              <a
                href="https://www.tiktok.com/@daigo.sushi?_t=ZN-8x9CwkVeuaE&amp;_r=1"
                target="_blank"
                className={styles.footer__socLink}
              >
                <svg
                  viewBox="0 0 27 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.0625 7.917V11.951C21.1352 11.771 19.2975 11.0961 17.75 10V14.5C17.7497 15.7211 17.384 16.9175 16.6946 17.952C16.0053 18.9865 15.0203 19.8174 13.8524 20.3493C12.6845 20.8813 11.3811 21.0929 10.0913 20.9599C8.80162 20.8268 7.57779 20.3545 6.56007 19.5971C5.54236 18.8397 4.77192 17.8278 4.33703 16.6773C3.90213 15.5268 3.82037 14.2843 4.10111 13.0921C4.38185 11.8999 5.01374 10.8062 5.92438 9.93642C6.83502 9.0666 7.98757 8.4558 9.25 8.174V12.5C8.88778 12.7557 8.60102 13.0943 8.41694 13.4836C8.23286 13.8729 8.15757 14.3001 8.19823 14.7245C8.2389 15.1489 8.39415 15.5565 8.64926 15.9086C8.90437 16.2606 9.25087 16.5455 9.65584 16.7361C10.0608 16.9266 10.5108 17.0166 10.9631 16.9975C11.4155 16.9783 11.8551 16.8507 12.2402 16.6266C12.6254 16.4026 12.9433 16.0896 13.1638 15.7174C13.3843 15.3452 13.5 14.9261 13.5 14.5V3H17.8382C18.0594 4.2284 18.6811 5.36162 19.6172 6.24263C20.5533 7.12363 21.7573 7.70878 23.0625 7.917Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.footer__bl}>
          <h2 className={styles.footer__title}>{t("footer.stay_connected")}</h2>

          <div className={styles.footer__contacts}>
            <a
              target="_blank"
              href="https://www.google.com/maps/@50.0487851,19.9461585,3a,75y,164.94h,92.56t/data=!3m10!1e1!3m8!1sBtSJet7sYErDivJTbd9dEQ!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D-2.5582101646556055%26panoid%3DBtSJet7sYErDivJTbd9dEQ%26yaw%3D164.94299002085444!7i16384!8i8192!9m2!1b1!2i46?entry=ttu&amp;g_ep=EgoyMDI1MDYxMS4wIKXMDSoASAFQAw%3D%3D"
              className={styles.footer__contactsLink}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 11C9 11.7956 9.31607 12.5587 9.87868 13.1213C10.4413 13.6839 11.2044 14 12 14C12.7956 14 13.5587 13.6839 14.1213 13.1213C14.6839 12.5587 15 11.7956 15 11C15 10.2044 14.6839 9.44129 14.1213 8.87868C13.5587 8.31607 12.7956 8 12 8C11.2044 8 10.4413 8.31607 9.87868 8.87868C9.31607 9.44129 9 10.2044 9 11Z"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M17.657 16.6572L13.414 20.9002C13.039 21.2748 12.5306 21.4853 12.0005 21.4853C11.4704 21.4853 10.962 21.2748 10.587 20.9002L6.343 16.6572C5.22422 15.5384 4.46234 14.1129 4.15369 12.5611C3.84504 11.0092 4.00349 9.40071 4.60901 7.93893C5.21452 6.47714 6.2399 5.22774 7.55548 4.3487C8.87107 3.46967 10.4178 3.00049 12 3.00049C13.5822 3.00049 15.1289 3.46967 16.4445 4.3487C17.7601 5.22774 18.7855 6.47714 19.391 7.93893C19.9965 9.40071 20.155 11.0092 19.8463 12.5611C19.5377 14.1129 18.7758 15.5384 17.657 16.6572Z"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <div className={styles.footer__contactsTxt}>
                {t("footer.address")}
              </div>
            </a>
            <a href={phoneNumHref} className={styles.footer__contactsLink}>
              <svg
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 1.5H7L9 6.5L6.5 8C7.57096 10.1715 9.32847 11.929 11.5 13L13 10.5L18 12.5V16.5C18 17.0304 17.7893 17.5391 17.4142 17.9142C17.0391 18.2893 16.5304 18.5 16 18.5C12.0993 18.263 8.42015 16.6065 5.65683 13.8432C2.8935 11.0798 1.23705 7.40074 1 3.5C1 2.96957 1.21071 2.46086 1.58579 2.08579C1.96086 1.71071 2.46957 1.5 3 1.5Z"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <div className={styles.footer__contactsTxt}>{phoneNum}</div>
            </a>
          </div>
        </div>

        <div className={styles.footer__bl}>
          <h2 className={styles.footer__title}>
            {t("footer.useful_links_title")}
          </h2>
          <p className={styles.footer__descript}>
            {t("footer.useful_links_description")}
          </p>
          <ul className={styles.footer__menu}>
            <li className={styles.footer__menuLi}>
              <Link to="/menu" className={styles.footer__menuLink}>
                {t("footer.menu_links.food")}
              </Link>
            </li>
            <li className={styles.footer__menuLi}>
              <Link to="/menu#drinks" className={styles.footer__menuLink}>
                {t("footer.menu_links.drinks")}
              </Link>
            </li>
            <li className={styles.footer__menuLi}>
              <Link to="/about-us" className={styles.footer__menuLink}>
                {t("footer.menu_links.about")}
              </Link>
            </li>
          </ul>

          <div className={styles.footer_manage}>
            <Link to="/manage">
              <AccountCircleIcon className={styles.manage} />
            </Link>
            <CookieConsentComponent />
          </div>
        </div>
      </div>

      <div className={styles.footer__bottom}>
        <div className={styles.footer__bottomTxt}>
          {t("footer.bottom.rights", { year: currentYear })}
        </div>
        <div className={styles.footer__bottomTxt}>
          {t("footer.bottom.design")}
        </div>
      </div>
    </footer>
  );
};
